<template>
  <b-card class="mb-2" :class="{ 'bg-success text-white': guest.checked }">
    <b-card-text>
      <b-form-checkbox v-model="guest.checked" @change="handleCheckboxChange">Checked</b-form-checkbox>
      <br>
      <div v-if="guest.isEditing">
        <b-form-group label="Cruise Line">
          <b-form-input v-model="guest.attributes.cruiseLine"></b-form-input>
        </b-form-group>
        <b-form-group label="Flight Number">
          <b-form-input v-model="guest.attributes.flightNumber"></b-form-input>
        </b-form-group>
        <b-form-group label="Feeder">
          <b-form-input v-model="guest.attributes.feeder"></b-form-input>
        </b-form-group>
        <b-form-group label="Guest Last Name">
          <b-form-input v-model="guest.attributes.guestsLastName"></b-form-input>
        </b-form-group>
        <b-form-group label="First Name">
          <b-form-input v-model="guest.attributes.firstName"></b-form-input>
        </b-form-group>
        <b-form-group label="Booking Number">
          <b-form-input v-model="guest.attributes.bookingNumber"></b-form-input>
        </b-form-group>
        <b-form-group label="Language">
          <b-form-input v-model="guest.attributes.language"></b-form-input>
        </b-form-group>
        <b-form-group label="Cabin Number">
          <b-form-input v-model="guest.attributes.cabinNumber"></b-form-input>
        </b-form-group>
        <b-form-group label="Note">
          <b-form-input v-model="guest.attributes.note"></b-form-input>
        </b-form-group>
        <b-form-group label="Remarks">
          <b-form-input v-model="guest.attributes.remarks"></b-form-input>
        </b-form-group>
        <b-form-group label="Additional Info">
          <b-form-input v-model="guest.attributes.additionalInfo"></b-form-input>
        </b-form-group>
        <b-button variant="success" size="sm" @click="saveGuestChanges">Save</b-button>
        <b-button variant="danger" size="sm" @click="toggleEditGuest" class="ml-2">Cancel</b-button>
      </div>
      <div v-else>
        <b>Guest Name:</b> {{ guest.attributes.guestsLastName }}, {{ guest.attributes.firstName }}<br>
        <b>Booking Number:</b> {{ guest.attributes.bookingNumber }}<br>
        <b>Language:</b> {{ guest.attributes.language }}<br>
        <b>Feeder:</b> {{ guest.attributes.feeder }}<br>
        <b>Cabin Number:</b> {{ guest.attributes.cabinNumber }}<br>
        <b>Note:</b> {{ guest.attributes.note }}<br>
        <b>Remarks:</b> {{ guest.attributes.remarks }}<br>
        <b>Additional Info:</b> {{ guest.attributes.additionalInfo }}<br>
        <b-button variant="outline-primary" size="sm" @click="addAdditionalInfo">+</b-button>
        <b-button variant="outline-secondary" size="sm" @click="toggleEditGuest" class="ml-2">
          <i class="fas fa-edit"></i>
        </b-button>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: 'GuestCard',
  props: {
    guest: {
      type: Object,
      required: true
    }
  },
  methods: {
    async handleCheckboxChange() {
      try {
        await this.$xhr.put(`/api/transfers/${this.guest.id}`, {
          data: { guestStatus: this.guest.checked ? 'Checked' : 'Unchecked' }
        });
        this.$emit('status-changed');
      } catch (error) {
        console.error('Error updating guest status:', error);
      }
    },
    toggleEditGuest() {
      this.$set(this.guest, 'isEditing', !this.guest.isEditing);
    },
    async saveGuestChanges() {
      const updateData = {
        cruiseLine: this.guest.attributes.cruiseLine,
        guestsLastName: this.guest.attributes.guestsLastName,
        firstName: this.guest.attributes.firstName,
        bookingNumber: this.guest.attributes.bookingNumber,
        language: this.guest.attributes.language,
        feeder: this.guest.attributes.feeder,
        cabinNumber: this.guest.attributes.cabinNumber,
        note: this.guest.attributes.note,
        remarks: this.guest.attributes.remarks,
        additionalInfo: this.guest.attributes.additionalInfo
      };

      try {
        await this.$xhr.put(`/api/transfers/${this.guest.id}`, {
          data: updateData
        });
        this.guest.isEditing = false;
        this.$emit('guest-updated');
      } catch (error) {
        console.error('Error saving guest changes:', error);
      }
    },
    async addAdditionalInfo() {
      const additionalInfo = prompt('Enter additional information:', this.guest.attributes.additionalInfo || '');
      if (additionalInfo !== null) {
        try {
          await this.$xhr.put(`/api/transfers/${this.guest.id}`, { data: { additionalInfo } });
          this.$set(this.guest.attributes, 'additionalInfo', additionalInfo);
        } catch (error) {
          console.error('Error adding info:', error);
        }
      }
    }
  }
};
</script>
